import { Component, Input, HostBinding } from '@angular/core';

import { RouterLink } from '@angular/router';
import { IconComponent } from '@app/shared/components/icon/icon';

export interface TopBarTitle {
  text: string;
  url?: string;
}
export interface TopBarItem {
  name: string;
  text: string;
  action?: () => void;
}

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [RouterLink, IconComponent],
  templateUrl: './top-bar.html',
  styleUrls: ['./top-bar.scss'],
})
export class TopBarComponent {
  @Input() title: TopBarTitle = { text: '' };
  @Input() items: TopBarItem[] = [];
  @Input() backgroundColor = 'var(--color-primary-700)';
  @HostBinding('style.--topbar-bg')
  get topbarBg(): string {
    return this.backgroundColor;
  }
}
